import { render, staticRenderFns } from "./Pep-statements-menu.vue?vue&type=template&id=25962d2a"
import script from "./Pep-statements-menu.vue?vue&type=script&lang=js"
export * from "./Pep-statements-menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports